import React from "react";
import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { hideScroll, sectionPx } from "./homeUi";

export function MediaRail({
  items,
  getKey,
  renderItem,
  spaceBetween = 10,
  breakpoints,
  slideStyle = { width: "auto" },
  swiperSx,
  gap = { xs: "10px", md: "14px", lg: "16px" },
  scrollSx,
  scrollOnly = false,
}) {
  if (!scrollOnly) {
    return (
      <Box
        component={Swiper}
        slidesPerView="auto"
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        modules={[Autoplay]}
        spaceBetween={spaceBetween}
        breakpoints={breakpoints}
        sx={{
          px: sectionPx,
          mt: { xs: "16px", md: "20px" },
          pb: 1,
          ...swiperSx,
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={getKey(item, index)} style={slideStyle}>
            {renderItem(item, index)}
          </SwiperSlide>
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        gap,
        overflowX: "auto",
        px: sectionPx,
        mt: { xs: "16px", md: "20px" },
        pb: 1,
        ...hideScroll,
        ...scrollSx,
      }}
    >
      {items.map((item, index) => (
        <React.Fragment key={getKey(item, index)}>
          {renderItem(item, index)}
        </React.Fragment>
      ))}
    </Box>
  );
}
